var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"justOne"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm._f("handleShowName")(_vm.item.name)))]),_c('span',{staticClass:"ask",on:{"click":_vm.toBottom}},[_vm._v("免费咨询")])]),_c('div',{staticClass:"center"},[_vm._v(_vm._s(_vm.item.contextStrs))]),_c('div',{staticClass:"bottom"},[(!_vm.isMobile)?_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(_vm.content.contentStr)}}):_c('div',{staticClass:"desc",domProps:{"innerHTML":_vm._s(
        _vm.content.mobileContentStr
          ? _vm.content.mobileContentStr
          : _vm.content.contentStr
      )}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }